import { AdmDataGrid } from "@components/common/data-grid/adm-data-grid";
import { AdmCompany } from "@custom-types/base-types";
import { useSearchWorkspacesTableColumns } from "@pages/home/search/search-tables/search-workspaces-tables/use-search-workspaces-table-columns";
import { useGenerateRoutes } from "@router/router-helper";
import { MainPageEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";

interface Props {
  /** List of companies that match the search text */
  companies: AdmCompany[];
}

/** Shows a list of workspaces that match the search text */
export function SearchWorkspacesTable({ companies }: Props): React.JSX.Element {
  const columns = useSearchWorkspacesTableColumns();
  const { generateCompanyRoute } = useGenerateRoutes();
  const { trackEvent } = useTrackEvent();

  return (
    <AdmDataGrid
      entities={companies}
      uniqueIdKey="id"
      tableType="search-companies-table"
      columns={columns}
      // Data is coming from somewhere else with error handling. So no need to show error in here.
      errorMessage=""
      shouldShowErrorMessage={false}
      onRowClick={() => {
        trackEvent({
          name: MainPageEvents.openItem,
          props: {
            target: "COMPANY",
            location: "search result",
          },
        });
      }}
      getRowLink={(company) => generateCompanyRoute({ companyId: company.id })}
      defaultSortModel={[{ field: "name", sort: "asc" }]}
    />
  );
}
